import { render, staticRenderFns } from "./FamilyHistory.vue?vue&type=template&id=fdc46d24&scoped=true"
import script from "./FamilyHistory.vue?vue&type=script&lang=js"
export * from "./FamilyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc46d24",
  null
  
)

export default component.exports